import MedicationSearcher from './MedicationSearcher.jsx';

export default MedicationSearcher;